
import moment from 'moment';
import UiInput3 from './ui_input3';
import UiToggle from './ui_toggle';
import UiButton3 from './ui_button3';
import UiTooltip from './ui_tooltip';
import BrandAuthStatus from './brand_auth_status';

const BrandFragment = ({
    // State variables
    search,
    setSearch,
    toggle,
    setToggle,
    sortMode,
    loading,
    // Data
    displayList,

    // Functions
    showCanvasHandler,
    sortModeHandler,
    navigate,

    // Other variables
    ww,
    baseUrl,

    // Optional loading state

}) => {
    return (
        <div style={{ maxWidth: 1600 }}>
            <div className={" d-flex flex-column gap-3 " + (ww < 400 ? "px-1 pt-4" : "p-4")}>

                <div className={"d-flex justify-content-between gap-1 " + (ww < 500 ? "flex-column" : "")}>
                    <p className="mb-1 fs-4">Brands</p>
                    <div className={`d-flex justify-content-end`}>
                        <div className={"d-flex gap-2 " + (ww < 450 ? "flex-column w-100" : "")}>

                            <div>
                                <UiInput3 value={search} setSearch={setSearch} />
                            </div>

                            <div>
                                <UiToggle setToggle={setToggle} />
                            </div>

                            <div>
                                <UiButton3
                                    text={"Add Account/Brand"}
                                    left={true}
                                    logo={baseUrl + "/src/plus.png"}
                                    submit={() => showCanvasHandler("Add Account/Brand", "add_brand")}
                                />
                            </div>

                        </div>
                    </div>
                </div>

                <BrandAuthStatus type="brand" brandLoad={loading} />

                <div className="container1">
                    <div className="table-responsive">
                        <table className="brand-table">
                            <thead>
                                <tr>
                                    <th onClick={sortModeHandler}>
                                        <div className='d-flex gap-1 justify-content-between' style={{ cursor: "pointer" }}>
                                            <span></span>
                                            <span className='text-truncate align-self-center'>Name</span>
                                            {sortMode == 1 ?
                                                <i className="bi bi-caret-up-fill align-self-center"></i>
                                                :
                                                <i className="bi bi-caret-down-fill align-self-center"></i>
                                            }
                                        </div>
                                    </th>
                                    <th className="middle-row-th">Account Type</th>
                                    <th className="middle-row-th">Start Date</th>
                                    <th className="middle-row-th">Status</th>
                                    <th className="middle-row-th">Action</th>
                                </tr>
                            </thead>

                            <tbody>
                                {displayList && displayList.filter(x => toggle ? x["active?"] == true : x["active?"] == false).map(x => (
                                    <tr key={x.id} className={x["active?"] ? "" : "text-secondary"}>

                                        <td
                                            style={{ cursor: "pointer", maxWidth: 220 }}
                                            onClick={() => navigate("/brand/auth/" + x.brand_entity_id)}

                                        >

                                            <div className={"text-truncate " + (x.has_error ? "" : "")}>
                                                <span>{x.brand}</span>
                                            </div>

                                        </td>

                                        <td
                                            style={{ cursor: "pointer" }}
                                            onClick={() => navigate("/brand/auth/" + x.brand_entity_id)}
                                            className="middle-row-td text-capitalize"
                                        >
                                            {x.account_type}
                                        </td>

                                        <td
                                            style={{ cursor: "pointer" }}
                                            onClick={() => navigate("/brand/auth/" + x.brand_entity_id)}
                                            className="middle-row-td"
                                        >
                                            {moment(x.created).format("MMM, D YYYY")}
                                        </td>

                                        <td className="middle-row-td">
                                            {/* <UiTooltip title="We are having a technical error, Status will be back soon.">
                                                <span className='poppins text-secondary'>n/a</span>
                                            </UiTooltip> */}
                                            {/* <span>{ x.marketplace_list.length}/{x.profile_list.length}</span>  */}
                                            {
                                                x.has_error ?
                                                    <div className="text-danger d-flex gap-1 justify-content-center">
                                                        <span>Issue</span>
                                                        <UiTooltip title="1 or more previously connected accounts for this Account/Brand are no longer connected. Immediate action required.">
                                                            <i className="bi bi-info-circle-fill"></i>
                                                        </UiTooltip>
                                                    </div>
                                                    :

                                                    x.marketplace_list.length == 0 && x.profile_list.length == 0 ?
                                                        <div className="d-flex gap-1 justify-content-center">
                                                            <span>Empty </span>
                                                            <UiTooltip title="Account/Brand was created but there are no marketplace accounts created yet.">
                                                                <i className="bi bi-info-circle-fill"></i>
                                                            </UiTooltip>
                                                        </div>
                                                        :

                                                        x.marketplace_list.length > x.profile_list.length ?
                                                            <div className="d-flex gap-1 justify-content-center">
                                                                <span>Pending</span>
                                                                <UiTooltip title="Account/Brand was created but there are no marketplace accounts connected yet.">
                                                                    <i className="bi bi-info-circle-fill"></i>
                                                                </UiTooltip>
                                                            </div>
                                                            :
                                                            <span className={x["active?"] ? "text-success" : "text-secondary"}>Connected</span>
                                            }
                                        </td>

                                        <td className="middle-row-td">
                                            <div className="d-flex gap-3 justify-content-center">
                                                <UiTooltip title="Edit">
                                                    <div
                                                        title="edit"
                                                        onClick={() => showCanvasHandler("Edit Account/Brand", "edit_brand", x.id)}
                                                        className=""
                                                        style={{ width: 20, height: 20, cursor: "pointer" }}
                                                    >
                                                        <img src={"/src/edit.png"} className="w-100" />
                                                    </div>
                                                </UiTooltip>

                                                <div className="" style={{ width: 20, height: 20 }}>
                                                    {x['active?'] ?
                                                        <UiTooltip title="Deactivate">
                                                            <img

                                                                onClick={() => showCanvasHandler("Deactivate this Account?", "off_brand", x.id)}
                                                                src={"/src/brand.png"}
                                                                className="w-100"
                                                            />
                                                        </UiTooltip>
                                                        :
                                                        <div className='d-flex justify-content-center gap-3 w-100'>
                                                            <UiTooltip title="Activate">
                                                                <img
                                                                    title="activate"
                                                                    onClick={() => showCanvasHandler("Activate Account", "on_brand", x.id)}
                                                                    src={"/src/brand-on.png"}
                                                                    className="w-100"
                                                                />
                                                            </UiTooltip>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </td>

                                    </tr>
                                ))}

                                {displayList.length == 0 && (
                                    <tr className="text-center">
                                        <td colSpan={5} className='poppins text-secondary'>Nothing to show...</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BrandFragment;